module.exports = __webpack_public_path__ + "static/img/pop_ico04.917bfeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pop_ico04.png
// module id = 80Em
// module chunks = 1